import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { AssignPlatformState } from "models/assignPlatform";

const initialState: AssignPlatformState = {
  loading: false,
  data: {},
  branddata: {},
  customerdata: {},
  storedata: {},
  platformdata: {},
  message: "",
  success: false,
  addAssignPlatformIsLoading: false,
  addAssignPlatformIsMessage: "",
  editAssignPlatformIsLoading: false,
  editAssignPlatformIsMessage: "",
};

const assignPlatformSlice = createSlice({
  name: "assignPlatform",
  initialState,
  reducers: {
    getAllAssignedAggregatorPlatforms(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.loading = true;
      state.message = "";
    },
    getAllAssignedAggregatorPlatformsSuccess(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getAllAssignedAggregatorPlatformsFailed(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getCustomersList(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getCustomersListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.customerdata = action.payload;
      state.success = action.payload.success;
    },
    getCustomersListFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getBrandsList(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getBrandsListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.branddata = action.payload;
      state.success = action.payload.success;
    },
    getBrandsListFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      // state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getStoresList(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getStoresListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.storedata = action.payload;
      state.success = action.payload.success;
    },
    getStoresListFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getPlatformsList(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getPlatformsListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.platformdata = action.payload;
      state.success = action.payload.success;
    },
    getPlatformsListFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    addAssignAggregatorPlatform(state, action: PayloadAction<ApiResponse>) {
      state.addAssignPlatformIsLoading = true;
      state.addAssignPlatformIsMessage = "";
    },
    addAssignAggregatorPlatformSuccess(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.addAssignPlatformIsLoading = false;
      state.addAssignPlatformIsMessage = action.payload.message;
      state.success = action.payload.success;
    },
    addAssignAggregatorPlatformFailed(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.addAssignPlatformIsLoading = false;
      state.addAssignPlatformIsMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateAssignAggregatorPlatform(state, action: PayloadAction<ApiResponse>) {
      state.editAssignPlatformIsLoading = true;
      state.editAssignPlatformIsMessage = "";
    },
    updateAssignAggregatorPlatformSuccess(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.editAssignPlatformIsLoading = false;
      state.editAssignPlatformIsMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateAssignAggregatorPlatformFailed(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.editAssignPlatformIsLoading = false;
      state.editAssignPlatformIsMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteAssignAggregatorPlatform(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    deleteAssignAggregatorPlatformSuccess(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    deleteAssignAggregatorPlatformFailed(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },

    changeBrandStatus(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    changeBrandStatusSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    changeBrandStatusFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.branddata = "";
    },
  },
});

//Actions
export const assignPlatformActions = assignPlatformSlice.actions;

//Selectors
export const getAssignPlatformData = (state: RootState) =>
  state.assignPlatform.data;
export const getCustomerData = (state: RootState) =>
  state.assignPlatform.customerdata;
export const getBrandData = (state: RootState) =>
  state.assignPlatform.branddata;
export const getStoreData = (state: RootState) =>
  state.assignPlatform.storedata;
export const getPlatformData = (state: RootState) =>
  state.assignPlatform.platformdata;
export const selectIsLoading = (state: RootState) =>
  state.assignPlatform.loading;
export const addAssignPlatformIsLoading = (state: RootState) =>
  state.assignPlatform.addAssignPlatformIsLoading;
export const addAssignPlatformIsMessage = (state: RootState) =>
  state.assignPlatform.addAssignPlatformIsMessage;

export const editAssignPlatformIsLoading = (state: RootState) =>
  state.assignPlatform.editAssignPlatformIsLoading;
export const editAssignPlatformIsMessage = (state: RootState) =>
  state.assignPlatform.editAssignPlatformIsMessage;
export const selectIsSuccess = (state: RootState) =>
  state.assignPlatform.success;
export const selectMessage = (state: RootState) => state.assignPlatform.message;

//Reducers
const assignPlatformReducer = assignPlatformSlice.reducer;
export default assignPlatformReducer;
